import './Footer.scss';
import { useBlockNumber } from 'wagmi';
import { socialMediaLinks } from '../../helpers/config/social-links';

function Footer() {
    const { data: blockNumber, isError } = useBlockNumber({
        watch: true
    });

    return (
        <footer className="Footer">
            <div className="content-container">
                <div className="Footer__leftSide">
                    {!isError && blockNumber ? (
                        <>
                            <div className="dark-green-circle">
                                <div className="light-green-circle"/>
                            </div>
                            <span className="ml-2 Footer__block-number">{blockNumber + ''}</span>
                        </>
                    ) : isError ? (
                        <>
                            <div className="outer-red-circle">
                                <div className="inner-red-circle"/>
                            </div>
                            <span className="ml-2 Footer__unstable">Unstable connection</span>
                        </>
                    ) : null}
                </div>
                <div className="Footer__rightSide">
                    <ul>
                        {socialMediaLinks.map((link, index) => (
                            <li key={index}><a target="_blank" rel="noopener noreferrer"  href={link.link}>{link.icon}</a></li>
                        ))}
                    </ul>
                </div>
            </div>
        </footer>
    );

}

export default Footer;